import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';

import {
  EXTERNAL_PURCHASE_DISCLOSURE_EVENT,
  resolveExternalPurchaseDisclosure,
} from '../utils/nativeCheckoutBridge';

const ExternalPurchaseDisclosureDialog: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleClose = useCallback((approved: boolean) => {
    setOpen(false);
    resolveExternalPurchaseDisclosure(approved);
  }, []);

  useEffect(() => {
    const onRequest = () => setOpen(true);
    window.addEventListener(EXTERNAL_PURCHASE_DISCLOSURE_EVENT, onRequest);
    return () => {
      window.removeEventListener(EXTERNAL_PURCHASE_DISCLOSURE_EVENT, onRequest);
    };
  }, []);

  return (
    <Dialog open={open} onClose={() => handleClose(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Continue to website for purchase</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          You are about to leave the app and complete your purchase on our website using a
          secure payment provider. Apple is not responsible for the privacy or security of
          payments made outside the app.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          After you finish checkout, return to the app and tap &quot;Refresh purchases&quot; if
          your content has not unlocked yet.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Cancel</Button>
        <Button variant="contained" onClick={() => handleClose(true)} autoFocus>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExternalPurchaseDisclosureDialog;
